import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import Input from 'antd/lib/input/index'
import Form from 'antd/lib/form/index'
import Button from 'antd/lib/button/index'
import { useNavigate } from 'react-router-dom'

import styles from './Login.module.scss'
const onFinishFailed = (errorInfo) => {
  console.log('Failed:', errorInfo)
}

const LoginPage = () => {
  const navigate = useNavigate()

  const onFinish = async (values) => {
    const response = await fetch('/api/auth/login', {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        name: values.name,
        password: values.password,
      }),
    })

    const body = await response.json()

    console.log(body)
    if (response.ok) {
      localStorage.setItem('admin_rme_token', body.token)
      navigate('/admin')
    } else {
      toast.error('Произошла ошибка, попробуйте снова', {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      })
    }
    console.log(response)
  }

  return (
    <div className={styles.page}>
      <Form
        name='basic'
        className={styles.form}
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 600,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete='off'
      >
        <Form.Item
          label='Username'
          name='name'
          rules={[
            {
              required: true,
              message: 'Please input your username!',
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label='Password'
          name='password'
          rules={[
            {
              required: true,
              message: 'Please input your password!',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 8,
            span: 16,
          }}
        >
          <Button type='primary' htmlType='submit'>
            Submit
          </Button>
        </Form.Item>
      </Form>
      {/* <form
          className={styles.contact_form}
          onSubmit={async (e) => {
            e.preventDefault()

            const response = await fetch('/api/auth/login', {
              headers: {
                'Content-Type': 'application/json',
              },
              method: 'POST',
              body: JSON.stringify({
                name,
                password,
              }),
            })

            const body = await response.json()

            console.log(body)
            if (response.ok) {
              localStorage.setItem('admin_rme_token', body.token)
              router.push('/admin')
            } else {
              toast.error('Произошла ошибка, попробуйте снова', {
                position: 'bottom-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
              })
            }
            console.log(response)
          }}
        >
          <input
            placeholder={'Логин'}
            name={'name'}
            onInput={(e) => setName(e.target.value)}
          />
          <input
            placeholder={'Пароль'}
            type={'password'}
            name={'password'}
            onInput={(e) => setPassword(e.target.value)}
          />
          <input
            type={'submit'}
            value={'Войти'}
          />
        </form>
      </div> */}
      <ToastContainer
        position='bottom-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      />
    </div>
  )
}

export default LoginPage
